import { useState } from "react"
import { MdClose } from "react-icons/md"
import { VscThreeBars } from "react-icons/vsc"

import { GgrUsageBadge } from "features/ggr/GgrUsageBadge"

import { useProps } from "../../contexts/PropsContext"
import { TwoFactorManageModal } from "../modals/ModalTwoFactorManage"
import { TwoFactorSetupModal } from "../modals/ModalTwoFactorSetup"

import { Sidebar } from "./Sidebar"
import { UserDropdown } from "./UserDropdown"

export const NavBar = ({ children }: { children: any }) => {
  const { authenticated, darkMode, refreshUser } = useProps()
  const [open, setOpen] = useState<boolean>(false)
  const [twoFactorModalOpen, setTwoFactorModalOpen] = useState(false)
  const [manageModalOpen, setManageModalOpen] = useState(false)

  const handle2FASuccess = () => {
    refreshUser()
  }

  return (
    <>
      <div className={`justify-between border-b-2 border-neutral navbar bg-base-300 lg:hidden ${darkMode ? "bg-[#12121b]" : "bg-white"}`}>
        <button className="lg:hidden" onClick={() => setOpen(!open)}>
          {open ? (
            <MdClose className="w-6 h-6 text-grey hover:text-black dark:hover:text-white" />
          ) : (
            <VscThreeBars className="w-6 h-6 text-grey hover:text-black dark:hover:text-white" />
          )}
        </button>
        {authenticated && (
          <div className="flex items-center gap-4 z-50">
            <GgrUsageBadge />
            <UserDropdown
              onOpenTwoFactorSetup={() => setTwoFactorModalOpen(true)}
              onOpenTwoFactorManage={() => setManageModalOpen(true)}
            />
          </div>
        )}
      </div>

      <Sidebar open={open} setOpen={setOpen}>
        {children}
      </Sidebar>

      <TwoFactorSetupModal isOpen={twoFactorModalOpen} onClose={() => setTwoFactorModalOpen(false)} onSuccess={handle2FASuccess} />
      <TwoFactorManageModal isOpen={manageModalOpen} onClose={() => setManageModalOpen(false)} onSuccess={handle2FASuccess} />
    </>
  )
}
